import React from 'react';
import PropTypes from 'prop-types';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { AlertIcon, CompleteIcon, DefaultIcon } from 'assets/materialIcons/materialIcons';
import { Table, TableBody, TableRow, TableRowColumn } from 'material-ui/Table';
import { colors } from 'material-ui/styles';
import { Link } from 'react-router-dom';
import Chip from 'components/ui/chip/Chip';

const styles = {
    table: {
        style: {
            tableLayout: 'auto',
            width: '100%',
        },
        wrapperStyle: {
            width: '100%',
        },
    },
    status: {
        paddingLeft: '5px',
        paddingRight: 0,
    },
    cell: {
        paddingRight: '5px',
        paddingLeft: '5px',
    },
};

class BookingActivitiesTable extends React.Component {
    static propTypes = {
        data: PropTypes.array.isRequired,
        translate: PropTypes.func.isRequired,
    }

    renderTableRowActor = (actor) => {
        let actorCompany = null,
            actorText = 'system';

        if (actor) {
            actorText = actor.name;

            if (actor.company_name) {
                actorCompany = `(${ actor.company_name })`;
            }
        }

        return (
            <div>
                <div>{ actorText }</div>
                { actorCompany &&
                    <div>{ actorCompany }</div>
                }
            </div>
        );
    }

    renderTableRowValue = (value) => {
        if (utils.isObject(value)) {
            value = `<strike>${ value.previous }</strike> \u2192 ${ value.current }`;
        }

        return value;
    }

    renderPropertyItems = (value, key) => {
        return (
            <TableRow key={ `${ key }_${ value }` }>
                <TableRowColumn style={ { whiteSpace: 'normal', padding: '10px 0', width: '50%' } }>{ key }</TableRowColumn>

                <TableRowColumn style={ { whiteSpace: 'normal', padding: '10px 0' } }>
                    <span dangerouslySetInnerHTML={ { __html: this.renderTableRowValue(value) } } ></span>
                </TableRowColumn>
            </TableRow>
        );
    }

    renderNestedPropertyItems = (values, key) => {
        return (
            <TableRow key={ `${ key }` }>
                <TableRowColumn style={ { whiteSpace: 'normal', padding: '10px 0', width: '25%' } }>{ key }</TableRowColumn>

                <TableRowColumn style={ { whiteSpace: 'normal', padding: '10px 0' } }>
                    {
                        utils.map(values, (itemValue, itemKey) => {
                            return (
                                <Table selectable={ false } key={ `table_${ itemValue }_${ itemKey }` }>
                                    <TableBody displayRowCheckbox={ false }>
                                        <TableRow key={ `${ key }_${ itemKey }_${ itemValue }` }>
                                            <TableRowColumn style={ { whiteSpace: 'normal', padding: '10px 0', borderBottom: `1px solid ${ theme.palette.silver }` } }>{ itemKey }</TableRowColumn>

                                            <TableRowColumn style={ { whiteSpace: 'normal', padding: '10px 0', borderBottom: `1px solid ${ theme.palette.silver }` } }>
                                                <span dangerouslySetInnerHTML={ { __html: this.renderTableRowValue(itemValue) } } ></span>
                                            </TableRowColumn>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            );
                        })
                    }
                </TableRowColumn>
            </TableRow>
        );
    }

    renderProperties = (activity) => {
        const { properties } = activity;

        if (utils.isEmpty(properties)) {
            return '-';
        }

        return (
            <Table selectable={ false }>
                <TableBody displayRowCheckbox={ false }>
                    {
                        utils.map(properties, (value, key) => {

                            // Check if the value is a Object.
                            if (utils.isObject(value)) {

                                // We need to check if the object does not contains the previous property.
                                if (!value.hasOwnProperty('previous')) {
                                    return this.renderNestedPropertyItems(value, key);
                                }
                            }

                            return this.renderPropertyItems(value, key);
                        })
                    }
                </TableBody>
            </Table>
        );
    }

    showIcon = (status) => {
        let icon;

        switch (status) {
            case 'success':
                icon = <CompleteIcon color={ colors.lightGreen600 }/>;
                break;
            case 'error':
                icon = <AlertIcon color={ colors.red400 }/>;
                break;
            default:
                icon = <DefaultIcon color={ colors.grey400 }/>;
                break;
        }

        return icon;
    }

    render() {
        const { data, translate } = this.props;

        if (!data) {
            return null;
        }

        return (
            <Table bodyStyle={ styles.table.wrapperStyle } selectable={ false } style={ styles.table.style }>
                <TableBody displayRowCheckbox={ false }>
                    <TableRow>
                        <TableRowColumn style={ styles.status }>{ translate('resources.orders.show.activities.booking.table.status') }</TableRowColumn>
                        <TableRowColumn style={ styles.cell }>{ translate('resources.orders.show.activities.booking.table.created_at') }</TableRowColumn>
                        <TableRowColumn style={ styles.cell }>{ translate('resources.orders.show.activities.booking.table.actor') }</TableRowColumn>
                        <TableRowColumn style={ styles.cell }>{ translate('resources.orders.show.activities.booking.table.activity') }</TableRowColumn>
                        <TableRowColumn style={ styles.cell }>{ translate('resources.orders.show.activities.booking.table.target_type') }</TableRowColumn>
                        <TableRowColumn style={ styles.cell }>{ translate('resources.orders.show.activities.booking.table.target_id') }</TableRowColumn>
                        <TableRowColumn style={ styles.cell } colSpan={ 3 }>{ translate('resources.orders.show.activities.booking.table.property') }</TableRowColumn>
                    </TableRow>

                    {
                        data.map((activity) => {
                            return (
                                <TableRow key={ `activity_${ activity.id }` }>
                                    <TableRowColumn style={ styles.status }>{ this.showIcon(activity.status) }</TableRowColumn>
                                    <TableRowColumn style={ styles.cell }>
                                        { utils.toDateString(
                                            utils.createDateTime(activity.created_at, true)
                                        ) }
                                    </TableRowColumn>
                                    <TableRowColumn style={ styles.cell }>{ this.renderTableRowActor(activity.actor) }</TableRowColumn>
                                    <TableRowColumn style={ styles.cell }>{ activity.activity }</TableRowColumn>
                                    <TableRowColumn style={ styles.cell }>{ activity.target_type }</TableRowColumn>
                                    <TableRowColumn style={ styles.cell }>
                                        {
                                            activity.target_type === 'reservation' ?
                                                (
                                                    <Link
                                                        to={ `/reservations/${ activity.target_id }/show` }
                                                        style={ { textDecoration: 'none', color: 'inherit' } }>
                                                        <Chip style={ { cursor: 'pointer' } }>{ activity.target_id }</Chip>
                                                    </Link>
                                                )
                                                :
                                                activity.target_id
                                        }
                                    </TableRowColumn>
                                    <TableRowColumn style={ styles.cell } colSpan={ 3 }>{ this.renderProperties(activity) }</TableRowColumn>
                                </TableRow>
                            );
                        })
                    }
                </TableBody>
            </Table>
        );
    }
}

export default translate(BookingActivitiesTable);



// WEBPACK FOOTER //
// ./src/pages/bookings/bookingActivities/booking/Table.js